import type { Brand } from '@finn-no/mobility-item-insertion-shared';
import pulse from '@finn-no/pulse-sdk';
import { Trans } from '@lingui/react/macro';
import '@warp-ds/components/icon';
import { getHuckConfig } from '../utils/getHuckConfig.js';

interface Props {
  className?: string;
}

export const TermsAndConditions = ({ className }: Props) => {
  const config = getHuckConfig();

  const termsLinks: Record<Brand, string> = {
    finn: 'https://hjelpesenter.finn.no/hc/no/articles/22619113173650-Annonseregler-for-FINN-no',
    dba: 'https://support.dba.dk/hc/da/articles/22323554955026-Annonceringsregler',
    blocket: 'https://www.blocket.se/om/villkor/annonseringsregler',
    bilbasen: '',
  };
  const termsLink = termsLinks[config.brand];

  const trackClick = () => () => {
    pulse.trackEvent({
      type: 'Click',
      intent: 'Open',
      name: 'Open advertising rules',
      object: {
        id: 'TAI_ev13',
        type: 'UIElement',
        elementType: 'Link',
      },
    });
  };

  return (
    <div className={`${className}`}>
      <Trans id="mobility-item-insertion.disclaimer" comment="Disclaimer text shown at the bottom of the form">
        By proceeding, you also{' '}
        <a href={termsLink} target="_blank" rel="noreferrer" onClick={trackClick()}>
          accept the advertising rules
          <w-icon
            name="LinkExternal"
            size="small"
            className="s-icon-primary ml-4 align-middle"
            locale={config.locale}
          />
        </a>
      </Trans>
    </div>
  );
};
